'use client';

import { c as _c } from "react/compiler-runtime";
import { useRouter } from 'next/navigation';
import { FeatherArrowRight, FeatherDollarSign } from '@subframe/core';
import { Button } from '@/shared/components/ui';
import type { PrioridadeHome } from '../types/prioridadesTypes';
import { EXIBIR_PRIORIDADES_HOME_MOCK, PRIORIDADES_HOME_MOCK } from '../utils/prioridadesHomeMock';
export function PrioridadesHome() {
  const $ = _c(16);
  const router = useRouter();
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== router) {
    t4 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const prioridades = EXIBIR_PRIORIDADES_HOME_MOCK ? PRIORIDADES_HOME_MOCK : [];
      const handleAbrirProcesso = prioridade => {
        router.push(`/arbitral/${prioridade.processoId}`);
      };
      if (prioridades.length === 0) {
        t4 = null;
        break bb0;
      }
      t2 = "flex flex-col gap-2";
      if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = <span className="text-caption-bold font-caption-bold text-subtext-color tracking-wider uppercase">Prioridades</span>;
        $[6] = t3;
      } else {
        t3 = $[6];
      }
      t0 = "flex flex-col gap-3";
      let t5;
      if ($[7] !== handleAbrirProcesso) {
        t5 = prioridade_0 => <div key={prioridade_0.id} className="border-warning-200 bg-warning-50 flex w-full flex-wrap items-center gap-4 rounded-[16px] border border-solid px-5 py-4"><div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-[8px] bg-white"><FeatherDollarSign className="text-warning-700 h-5 w-5" /></div><div className="flex min-w-[220px] flex-1 flex-col"><span className="text-body-bold font-body-bold text-warning-900">{prioridade_0.titulo}</span><span className="text-caption font-caption text-warning-700">{prioridade_0.subtitulo}</span><span className="text-caption font-caption text-warning-700 tabular-nums">{prioridade_0.detalhe}</span></div><Button variant="brand-primary" size="medium" iconRight={<FeatherArrowRight />} onClick={() => handleAbrirProcesso(prioridade_0)}>Pagar custas</Button></div>;
        $[7] = handleAbrirProcesso;
        $[8] = t5;
      } else {
        t5 = $[8];
      }
      t1 = prioridades.map(t5);
    }
    $[0] = router;
    $[1] = t0;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t0 = $[1];
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
  }
  if (t4 !== Symbol.for("react.early_return_sentinel")) {
    return t4;
  }
  let t5;
  if ($[9] !== t0 || $[10] !== t1) {
    t5 = <div className={t0}>{t1}</div>;
    $[9] = t0;
    $[10] = t1;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t2 || $[13] !== t3 || $[14] !== t5) {
    t6 = <div className={t2}>{t3}{t5}</div>;
    $[12] = t2;
    $[13] = t3;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}